import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const NAMESPACES = ['common', 'auth', 'dashboard', 'products', 'categories', 'stock', 'warehouses', 'suppliers', 'customers', 'reports', 'setup'] as const;
export type Namespace = (typeof NAMESPACES)[number];

void i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: 'es-AR',
    fallbackLng: 'es-AR',
    defaultNS: 'common',
    ns: [...NAMESPACES],

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    // Use React Suspense for loading state
    react: {
      useSuspense: true,
    },

    debug: import.meta.env.DEV,
  });

export default i18n;
